import AdminStatsPanel from './admin/AdminStatsPanel.js';
import AdminUsersPanel from './admin/AdminUsersPanel.js';

/**
 * Admin dashboard: stats + user moderation (Dezoom-style, no puzzles).
 */
export default class AdminScreen {
  constructor({ auth, onBack }) {
    this.auth = auth;
    this.onBack = onBack;
    this.tab = 'stats';

    this.guardEl = document.getElementById('admin-guard');
    this.dashboardEl = document.getElementById('admin-dashboard');
    this.tabsEl = document.getElementById('admin-tabs');
    this.panelEl = document.getElementById('admin-panel');

    document.getElementById('btn-admin-back')?.addEventListener('click', () => this.onBack?.());

    this.tabsEl?.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-admin-tab]');
      if (!btn) return;
      this.tab = btn.dataset.adminTab;
      this._syncTabs();
      this._loadPanel();
    });

    this.statsPanel = new AdminStatsPanel({ api: auth.api, root: this.panelEl });
    this.usersPanel = new AdminUsersPanel({
      api: auth.api,
      root: this.panelEl,
      currentUserId: null,
    });
  }

  refresh() {
    const user = this.auth.user;

    if (!user) {
      this.guardEl?.classList.remove('hidden');
      this.dashboardEl?.classList.add('hidden');
      if (this.guardEl) {
        this.guardEl.innerHTML = `
          <p class="admin-msg">Connecte-toi pour accéder à l'administration.</p>
          <button type="button" class="btn btn--secondary" id="btn-admin-to-account"><span>MON COMPTE</span></button>
        `;
        this.guardEl.querySelector('#btn-admin-to-account')?.addEventListener('click', () => {
          this.onBack?.('account');
        });
      }
      return;
    }

    if (!user.isAdmin) {
      this.guardEl?.classList.remove('hidden');
      this.dashboardEl?.classList.add('hidden');
      if (this.guardEl) {
        this.guardEl.innerHTML = `
          <h2 class="admin-title">Administration</h2>
          <p class="admin-msg">Accès interdit.</p>
          <button type="button" class="btn btn--secondary" id="btn-admin-forbidden-back"><span>MENU</span></button>
        `;
        this.guardEl.querySelector('#btn-admin-forbidden-back')?.addEventListener('click', () => this.onBack?.());
      }
      return;
    }

    this.guardEl?.classList.add('hidden');
    this.dashboardEl?.classList.remove('hidden');
    this.usersPanel.currentUserId = user.id;
    this._syncTabs();
    this._loadPanel();
  }

  _syncTabs() {
    this.tabsEl?.querySelectorAll('[data-admin-tab]').forEach((btn) => {
      const active = btn.dataset.adminTab === this.tab;
      btn.classList.toggle('active', active);
      btn.setAttribute('aria-selected', String(active));
    });
  }

  _loadPanel() {
    if (this.tab === 'stats') this.statsPanel.load();
    else this.usersPanel.load();
  }
}
